import React from "react";

import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import {
  MdmObjectDto,
  useCreateObjectMutation
} from "gql/generated/types";
import { useNavigate, useParams } from "react-router-dom";
import { GET_OBJECTS_BY_PROJECT } from "gql/object.operations";
import ObjectForm from "../components/ObjectForm";

const NewObjectForm = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [createObjectMutation, { loading }] = useCreateObjectMutation({
    onCompleted: () => {
      easasAlert({
        severity: "success",
        summary: "Success",
        detail: "Object updated successfully",
        life: 3000,
      });
      navigate(`/mdm/${projectId}/`);
    },
    onError: err => {
      easasAlert({ severity: "error", summary: "Error", detail: err.message, life: 3000 });
    },
  });
 
  const handleCreate = (object: MdmObjectDto) => {
    createObjectMutation({
      variables: { object: { ...object, projectId } },
      update: (cache, { data }) => {
        cache.updateQuery({ query: GET_OBJECTS_BY_PROJECT, variables: {id: projectId}}, (oldData) => ({ 
          mdmObjectsByProjectId: [...oldData.mdmObjectsByProjectId, data?.createMdmObject]
        }) );
      }
    });
  };

  return <ObjectForm object={null} onSubmit={handleCreate} loading={loading} />;
};

export default NewObjectForm;
